import MainLayout from "@/components/layout/admin/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { mapGetters } from "vuex";
import store from "../../../store";

export default {
    name: "companyList",
    
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            companyList: {},
            keyword: "",
            page_status: false
        };
    },

    computed: {
        ...mapGetters({ isCompanyLoggedIn: "isCompanyLoggedIn", companyToken: "companyToken" })
    },

    methods: {
        getCompany(page = 1) {
            axios.get("/company/list?page=" + page)
                .then(response => {
                    this.companyList = response.data;
                })
                .catch(error => {
                    console.log("Company List API Error", error);
                });
        },

        searchCompany(page = 1) {
            var request = {
                params: {
                    keyword: this.keyword
                }
            }
            axios.get("/company/search/result?page="+page, request)
                .then(response => {
                    this.page_status = true;
                    this.companyList = response.data;
                })
                .catch(error => {
                    console.log("Company Search API Error", error);
                });
        },

        confirmDelete(id) {
            if (window.confirm("Are you sure?")) {
                this.deleteCompany(id);
            } else {
                console.log("no");
            }
        },

        deleteCompany(id) {
            axios.delete("/company/delete/" + id)
                .then(response => {
                    this.companyList = response.data;
                    this.getCompany();
                })
                .catch(error => {
                    console.log("Company Delete Error->", error.response.data);
                });
        },

        loginCompany(id) {
            var request = {
                id: id
            };
            axios.post("/company/login", request)
                .then(( {data} ) => {
                    store.commit("setCompanyData", data);
                    let routeData = this.$router.resolve({
                        path: '/company/index'
                    });
                    window.open(routeData.href, '_blank');
                })
                .catch(error => {
                    console.log("signup error", error);
                });
        },
    },

    mounted() {
        this.getCompany();
    }
};